import styled from "styled-components";
import { COLORS, responsive } from "../../../../../../styles/constants.style";

export const TabsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.cirrus_black1};
  gap: 32px;

  ${responsive.MOBILE`
    gap: 16px;
  `}
  .content {
    padding: 0px 16px 24px 16px;
    width: 100%;
    ${responsive.MOBILE`
      padding: 0px 16px 16px 8px;
    `}

    .section-grid-container {
      margin-top: 24px !important;

      ${responsive.MOBILE`
        margin-top: 8px !important;
      `}
    }
  }

  .sponsoring-employer-grid {
    padding-bottom: 0;
  }

  .content-skill-keywords,
  .content-target-job-title {
    ${responsive.MOBILE`
      padding: 0px 16px 0px 8px;
    `}
  }

  .activity-timeline {
    padding-top: 16px;

    .MuiGrid2-container {
      padding: 0px;
      margin-top: 0;
    }

    .filter-wrapper {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      justify-content: flex-start;
      padding: 16px;
      padding-right: 0;
      border-bottom: 1px solid ${COLORS.cirrus_black4};

      .add-activity-wrapper {
        margin-left: auto;
        margin-right: 24px;
      }
      ${responsive.TABLET_PORTRAIT`
        flex-direction: column; 
        align-items: flex-start; 
        .modality {
          margin-left: 0;
          margin-top: 10px;
        }
        .add-activity-wrapper {
          margin-left: 0;
          margin-top: 10px;
        }
      `}

      ${responsive.MOBILE`
        padding-left: 8px;
      `}
    }

    .next-contact-date-wrapper {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      justify-content: flex-start;
      padding-bottom: 16px;
      padding-left: 16px;
      border-bottom: 1px solid ${COLORS.cirrus_black4};

      ${responsive.TABLET_PORTRAIT`
              flex-direction: column; 
              align-items: flex-start; 
            `}
    }

    .duration-picker-wrapper {
      background: ${COLORS.cirrus_black2};
      padding: 16px;

      ${responsive.MOBILE`
        padding: 16px 8px;
      `}

      .go-btn-grid {
        display: flex;

        ${responsive.MOBILE`
          margin-top: 8px;
        `}

        .MuiButtonBase-root {
          margin-top: auto;
        }
      }
    }
  }
`;
